<dl [class.horizontal-aligned]="horizontalAligned()">
  <dt>{{ 'patient.patient-number' | translate }}:</dt>
  <dd>{{ patient().patient_number }}</dd>

  @if (patient().external_id) {
    <dt>{{ 'patient.external-id' | translate }}:</dt>
    <dd>{{ patient().external_id }}</dd>
  }

  <dt>{{ 'common.name' | translate }}:</dt>
  <dd>{{ formatPatientName(patient()) }}</dd>

  <dt>{{ 'patient.date-of-birth' | translate }}:</dt>
  <dd>{{ patient().date_of_birth | localDateFormat }}</dd>

  @if ('patient.gender.option.' + patient().gender?.toLowerCase() | translate) {
    <dt>{{ 'patient.gender.label' | translate }}:</dt>
    <dd>
      {{ 'patient.gender.option.' + patient().gender?.toLowerCase() | translate }}
    </dd>
  }
</dl>

<div class="fw-bold mb-1">{{ 'patient.details-page.contact-details' | translate }}:</div>

<div class="horizontal-aligned">
  @if (patient().email) {
    <div>{{ 'common.email' | translate }}:</div>
    <div>{{ patient()!.email }}</div>
  }
  @if (patient().phone) {
    <div>{{ 'common.phone' | translate }}:</div>
    <div>{{ patient()!.phone }}</div>
  }
  @if (patient().mobile) {
    <div>{{ 'patient.mobile' | translate }}:</div>
    <div>{{ patient()!.mobile }}</div>
  }
  @if (patient().street || patient().city) {
    <div>{{ 'common.address' | translate }}:</div>
    <div>
      {{ patient()!.street }} {{ patient()!.house_number }}<br />
      {{ patient()!.postal_code }} {{ patient()!.city }}
    </div>
  }
</div>
